import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Jumbotron, Button, FormControl, Row, Col, ControlLabel, InputGroup } from 'react-bootstrap';
import Geosuggest from 'react-geosuggest';
import ReactTelInput from 'react-telephone-input';
import _ from 'lodash';

import MapModalComponent from './MapModalComponent';
import CitiesComponent from './settings/components/CitiesComponent';
import CountriesComponent from './settings/components/CountriesComponent';
import { gettext } from '../i18n/service.js';
import * as Validation from '../businessLogic/fieldValidation.js';

import * as settingsActions from '../actions/dispatcherRegisterActions';
import * as appActions from '../actions/appActions';
import * as fleetActions from '../actions/fleetOwnerActions';

export class DispatcherRegisterForm extends React.Component {

  constructor(props) {
    super(props);
    
    this.state = {
      isShowingMap: false
    };

    this.addToDefaultTeam = false;
    this.newPickupPoint = {};
    this.selectedPickupPoint = {};
    this.selectedDispatcher = undefined;
    this.geocoder = new window.google.maps.Geocoder();


    _.bindAll(this, ['validateDispatcherFields', 'createNewDispatcher', 'showMapEdit', 'hideMapEdit',
    'onMapClick', 'renderNewPickupPoint']);
  }

  createNewDispatcher() {
    if (!this.validateDispatcherFields())
      return false;
    else if (!Validation.passValdationForCreating(this.state.password, this.props.showMessage))
      return false;
    else if (!Validation.pickupPointValidation(this.newPickupPoint, this.props.showMessage))
      return false;
    else {
      delete this.state['confirmPassword'];
      delete this.state.filterValue;
      this.state.companyId = this.props.company.id;
     // this.props.startSpinner();
      const data = {
        "email": this.state.email,
        "firstName": this.state.firstName,
        "lastName":  this.state.firstName,
        "mobile": this.state.mobile,
        "password": this.state.password,
        "phone": this.state.phone,
        "shopName": this.state.shopName,
        "address": this.newPickupPoint.address,
        "title": this.newPickupPoint.title,
        "gpsLocation":{
            "lat": this.newPickupPoint.gpsLocation.lat,
            "lng": this.newPickupPoint.gpsLocation.lng
            },
        "pickUpPointContactName": this.newPickupPoint.contactName,
        "pickUpPointPhone": this.newPickupPoint.phone,
        "dispatcherLocationCity": this.props.cityId,
        "dispatcherLocationCountry": this.props.countryId
      };

      this.props.settingsActions.register(data);
    }
  }

  validateDispatcherFields() {
    return Validation.emailValdation(this.state.email, this.props.showMessage)
      && Validation.nameValidation(this.state.firstName, this.props.showMessage)
      && Validation.passValdation(this.state.password, this.state.confirmPassword, this.props.showMessage)
      && Validation.phoneValdation(parseInt(this.state.phone), this.props.showMessage)
      && Validation.mobileValdation(parseInt(this.state.mobile), this.props.showMessage)
      && Validation.countryValdation(this.props.countryId, this.props.showMessage)
      && Validation.cityValdation(this.props.cityId, this.props.showMessage)
  }

  showMapEdit() {
    this.setState({isShowingMap : true });
    this.forceUpdate();
  }

  hideMapEdit() {
    this.setState({isShowingMap : false });
    this.forceUpdate();
  }

  onMapClick({ latLng }) {
    const location = {
      lat: latLng.lat(),
      lng: latLng.lng()
    };

    this.geocoder.geocode({ location: location }, (results) => {
      if (this.newPickupPoint.toCreate) {
        this.newPickupPoint.gpsLocation = location;
        this.newPickupPoint.address = results[0].formatted_address;
      }

      if (this.selectedPickupPoint.id) {
        this.selectedPickupPoint.gpsLocation = location;
        this.selectedPickupPoint.address = results[0].formatted_address;
      }
      this.hideMapEdit();
    });
  }

  renderNewPickupPoint() {
    this.newPickupPoint.toCreate = true;
    return (
      <div className="user_data center_div">
        <Row>
          <Col sm={4}>
            <ControlLabel><h4>{gettext('TITLE')}</h4></ControlLabel>
          </Col>
          <Col sm={8}>
            <FormControl
              type="text"
              required={true}
              onChange={(e) => this.newPickupPoint.title = e.target.value}
              placeholder={gettext('TITLE')} />
          </Col>
        </Row>
        <Row>
          <Col sm={4}>
            <ControlLabel><h4>{gettext('CONTACT-NAME')}</h4></ControlLabel>
          </Col>
          <Col sm={8}>
            <FormControl
              type="text"
              required={true}
              onChange={(e) => this.newPickupPoint.contactName = e.target.value}
              placeholder={gettext('CONTACT-NAME')} />
          </Col>
        </Row>
        <Row>
          <Col sm={4}>
            <ControlLabel><h4>{gettext('PHONE')}</h4></ControlLabel>
          </Col>
          <Col sm={8}>
            <ReactTelInput
              required={true}
              defaultCountry="sa"
              preferredCountries={['sa']}
              flagsImagePath="./flags.png"
              onChange={(telNumber, selectedCountry) => {
                this.newPickupPoint.phone = parseInt(telNumber.replace(/[^0-9]/g, ''), 10)
              }}
            />
          </Col>
        </Row>
        <Row>
          <Col sm={4}>
            <ControlLabel><h4>{gettext('ADDRESS')}</h4></ControlLabel>
          </Col>
          <Col sm={8}>
            <InputGroup>
              <Geosuggest
                required={true}
                name="defaultPickUpPoint"
                placeholder={gettext('ADDRESS')}
                inputClassName="_recipient_ _order_ form-control"
                initialValue={this.newPickupPoint.address}
                onSuggestSelect={(opts) => {
                  this.newPickupPoint.gpsLocation = opts.location;
                  this.newPickupPoint.address = opts.label;
                }
                } />
              <InputGroup.Addon onKeyDown={(e) => props.onKeyDown(e)}
                onClick={() => this.showMapEdit()}>
                {gettext('SELECT-ON-MAP')}
              </InputGroup.Addon>
            </InputGroup>
          </Col>
        </Row>
      </div>
    );
  }

  render() {
    const { isShowingMap } = this.state;
    const maps = isShowingMap ?
      (
        <MapModalComponent
          onMapClick={this.onMapClick}
          onClickOutsideOfMap={this.hideMapEdit}
          onCancel={this.hideMapEdit}
          hideMapEdit={this.hideMapEdit}
        />
      )
      : '';

    return (
      <div className="dispatcher-register">
        <Jumbotron className="position_relative">          
          <div className="user_data center_div">
            <Row>
              <Col sm={4}>
                <ControlLabel><h4>{gettext('EMAIL')}</h4></ControlLabel>
              </Col>
              <Col sm={8}>
                <FormControl
                  type="text"
                  required={true}
                  onChange={(e) => this.setState({ email: e.target.value })}
                  placeholder={gettext('EMAIL')} />
              </Col>
            </Row>
            <Row>
              <Col sm={4}>
                <ControlLabel><h4>{gettext('PASSWORD')}</h4></ControlLabel>
              </Col>
              <Col sm={8}>
                <FormControl
                  type="password"
                  required={true}
                  onChange={(e) => this.setState({ password: e.target.value })}
                  placeholder={gettext('PASSWORD')} />
              </Col>
            </Row>
            <Row>
              <Col sm={4}>
                <ControlLabel><h4>{gettext('CONFIRM-PASSWORD')}</h4></ControlLabel>
              </Col>
              <Col sm={8}>
                <FormControl
                  type="password"
                  required={true}
                  onChange={(e) => this.setState({ confirmPassword: e.target.value })}
                  placeholder={gettext('CONFIRM-PASSWORD')} />
              </Col>
            </Row>      
            <Row>
              <Col sm={4}>
                <ControlLabel><h4>{gettext('FIRST-NAME')}</h4></ControlLabel>
              </Col>
              <Col sm={8}>
                <FormControl
                  type="text"
                  required={true}
                  onChange={(e) => this.setState({ firstName: e.target.value })}
                  placeholder={gettext('FIRST-NAME')} />
              </Col>
            </Row>
            <Row>
              <Col sm={4}>
                <ControlLabel><h4>{gettext('LAST-NAME')}</h4></ControlLabel>
              </Col>
              <Col sm={8}>
                <FormControl
                  type="text"
                  required={true}
                  onChange={(e) => this.setState({ lastName: e.target.value })}
                  placeholder={gettext('LAST-NAME')} />
              </Col>
            </Row>
            <Row>
              <Col sm={4}>
                <ControlLabel><h4>{gettext('SHOP-NAME')}</h4></ControlLabel>
              </Col>
              <Col sm={8}>
                <FormControl
                  type="text"
                  required={true}
                  onChange={(e) => this.setState({ shopName: e.target.value })}
                  placeholder={gettext('SHOP-NAME')} />
              </Col>
            </Row>
            <Row>
              <Col sm={4}>
                <ControlLabel><h4>{gettext('MOBILE')}</h4></ControlLabel>
              </Col>
              <Col sm={8}>
                <ReactTelInput
                  required={true}
                  defaultCountry="sa"
                  preferredCountries={['sa']}
                  flagsImagePath="./flags.png"
                  onChange={(telNumber) => {
                    this.setState({ mobile: parseInt(telNumber.replace(/[^0-9]/g, ''), 10) })
                  }}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={4}>
                <ControlLabel><h4>{gettext('PHONE-NUMBER')}</h4></ControlLabel>
              </Col>
              <Col sm={8}>
                <ReactTelInput
                  required={true}
                  defaultCountry="sa"
                  preferredCountries={['sa']}
                  flagsImagePath="./flags.png"
                  onChange={(telNumber) => {
                    this.setState({ phone: parseInt(telNumber.replace(/[^0-9]/g, ''), 10) })
                  }}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={4}>
                <ControlLabel><h4>{gettext('COUNTRY')}</h4></ControlLabel>
              </Col>
              <Col sm={8}>
                <CountriesComponent
                  countries={this.props.countries}
                  onSelect={this.props.setCountry}
                  clearCity={this.props.clearCity} />
              </Col>
            </Row>
            <Row>
              <Col sm={4}>
                <ControlLabel><h4>{gettext('CITY')}</h4></ControlLabel>
              </Col>
              <Col sm={8}>
                <CitiesComponent
                cities={this.props.cities}
                onSelect={this.props.setCity}
                clearCity={this.props.clearCity}
                />
              </Col>
            </Row>
            
          </div>
          <div className="botom_line" />
          <div className="text_align_center margin_bottom_em">
            <h3>{gettext('PICK-UP-POINTS')}</h3>
          </div>
          {this.renderNewPickupPoint()}          
          <div className="actions">
            <Button bsStyle="primary" onClick={() => this.createNewDispatcher()}>{gettext('AUTH.SIGN-UP')}</Button>
          </div>
        </Jumbotron>
        {maps}
      </div>
    );
  } 
}

DispatcherRegisterForm.propTypes = {
  dispatchers: PropTypes.array
};

function mapStateToProps(state) {
  return {
    dispatchers: state.settingsPageReducer.dispatchers,
    company: state.appReducer.company,
    account: state.appReducer.account,
    pickUpPoints: state.settingsPageReducer.pickUpPoints,
    createdDispatcher: state.settingsPageReducer.createdDispatcher,
    cities: state.settingsPageReducer.cities
  };
}

function mapDispatchToProps(dispatch) {
  return {
    settingsActions: bindActionCreators(settingsActions, dispatch),
    appActions:  bindActionCreators(appActions, dispatch),
    fleetActions:  bindActionCreators(fleetActions, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DispatcherRegisterForm);



// WEBPACK FOOTER //
// ./src/components/DispatcherRegisterForm.js